import store from 'Redux/store';

export const ERROR_MESSAGE = 'frontend/error-messages/CART_ERROR_MESSAGE';
export const RESET_MESSAGE = 'frontend/error-messages/RESET_MESSAGE';

export function resetErrorMessage() {
  return store.dispatch({ type: RESET_MESSAGE });
}
